<template>
    <v-main :class="`account-teaser ${mode}`" v-if="user">
        <v-row no-gutters>
            <v-col class="content">
                <typo name="title-30-bold" data-hj-suppress>
                    <typo name="title-30-normal">
                        {{ dico.title }}
                    </typo>
                    {{ user.firstName }} {{ user.lastName }}
                </typo>
                <sep name="S" />
                <typo
                    name="title-16-bold"
                    style="text-transform: uppercase"
                    v-if="user.subscription"
                >
                    {{ user.subscription.contract.label }}
                </typo>
                <sep name="M" v-if="mode == 'dashboard'" />
                <typo name="body-16-light" v-if="mode == 'dashboard'">
                    {{ dico.text }}
                </typo>
                <sep name="L" />
                <div class="buttons">
                    <router-link :to="dico.links.cgu.to">
                        <action :name="mode == 'dashboard' ? 'light' : 'light-outlined'">
                            {{ dico.links.cgu.label }}
                        </action>
                    </router-link>
                    <router-link v-if="mode == 'dashboard'" :to="dico.links.account.to">
                        <action name="light">
                            {{ dico.links.account.label }}
                        </action>
                    </router-link>
                </div>
            </v-col>
            <v-col class="cover" v-if="mode == 'dashboard'"> </v-col>
        </v-row>
    </v-main>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    props: ["mode", "user"],
    computed: {
        dico() {
            return this.$privateDico.teaser;
        },
    },
});
</script>

<style lang="sass" scoped>
.account-teaser
    background: $color-yellow

.cover
    background: url(src/assets/images/teaser-entreprise.jpg)
    background-size: cover
    background-position: center

.content
    padding: $grid-gutter*2
    min-height: 300px
    display: flex
    flex-direction: column

.buttons
    display: flex
    margin-top: auto
    .action
        margin-right: $grid-gutter

.account-teaser.account
    background: $color-secondary
    .typo
        color: white
    .content
        min-height: inherit
</style>
